import { NgModule } from '@angular/core';
import { FormatMailboxMessageCountPipe } from './format-mailbox-message-count.pipe';

@NgModule({
   declarations: [FormatMailboxMessageCountPipe],
   exports: [FormatMailboxMessageCountPipe],
})
export class FormatMailboxMessageCountPipeModule {}